var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"qrcode-page"},[_c('img',{staticClass:"qrcode_page_img",attrs:{"src":require("../../assets/qrcode_page.png")}})])])}]

export { render, staticRenderFns }